import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ReviewSection from '../components/ReviewSection';

const morningSlots = ['9:00 AM','9:30 AM','10:00 AM','10:30 AM','11:00 AM','11:30 AM'];
const afternoonSlots = ['12:00 PM','12:30 PM','1:00 PM','1:30 PM','2:00 PM','2:30 PM'];
const eveningSlots = ['3:00 PM','3:30 PM','4:00 PM','4:30 PM','5:00 PM','5:30 PM','6:00 PM'];

const SlotPicker = ({ doctor }) => {
  const [selected, setSelected] = useState(null);

  const SlotBtn = ({ time }) => (
    <button onClick={() => setSelected(time)}
      style={{
        padding: '6px 0', fontSize: 12, borderRadius: 3, cursor: 'pointer',
        border: selected === time ? '1.5px solid #39a5d3' : '1px solid #d0e0ea',
        background: selected === time ? '#e8f4fb' : '#fff',
        color: selected === time ? '#39a5d3' : '#444',
        fontWeight: selected === time ? 700 : 400,
        fontFamily: 'inherit', transition: 'all 0.1s', width: '31%',
      }}>
      {time}
    </button>
  );

  const handleBook = () => {
    const params = new URLSearchParams({
      doctor: doctor.name,
      clinic: doctor.clinic,
      slot: selected,
      phone: doctor.phone,
    });
    window.location.href = `/book-appointment?${params.toString()}`;
  };

  const allSlots = [...morningSlots, ...afternoonSlots, ...eveningSlots];

  return (
    <div style={{ padding: '14px 18px' }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#19354a', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>Mon – Sat</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 14 }}>
        {allSlots.map(t => <SlotBtn key={t} time={t} />)}
      </div>
      {selected && (
        <div style={{ padding: '8px 12px', background: '#f0f7fb', borderRadius: 3, fontSize: 12, color: '#19354a', marginBottom: 10 }}>
          Selected: <strong>{selected}</strong>
        </div>
      )}
      <button onClick={handleBook} disabled={!selected}
        style={{
          width: '100%', padding: '11px 0', fontSize: 13, fontWeight: 700,
          background: selected ? '#39a5d3' : '#e8e8e8',
          color: selected ? '#fff' : '#aaa',
          border: 'none', borderRadius: 3,
          cursor: selected ? 'pointer' : 'not-allowed',
          fontFamily: 'inherit',
        }}>
        {selected ? 'Book Appointment' : 'Select a Time Slot'}
      </button>
    </div>
  );
};

const doctor = {
  name: 'Dr. Madan',
  specialty: 'Surgeon',
  qual: 'MBBS, MS — General Surgery & Multi-Specialty',
  initials: 'MD',
  color: '#0F6E56',
  verified: true,
  image: '',
  clinic: 'Akropolis Super Specialty Hospital',
  location: 'Sohna, Haryana 122103',
  city: 'Sohna',
  fee: 1000,
  hours: 'Mon–Sat: 9:00 AM–7:00 PM',
  phone: '7030009030',
  email: '',
  website: '',
  googleMaps: '',
  about: 'Dr. Madan is a surgeon at Akropolis Super Specialty Hospital in Sohna, Haryana — a multi-specialty hospital serving patients across Sohna and the greater Gurugram region. He provides surgical consultation and procedures across general and laparoscopic surgery, supporting the hospital\'s multi-specialty care model.',
  services: [
    'General Surgery', 'Laparoscopic Surgery', 'Hernia Repair',
    'Appendectomy', 'Gallbladder Surgery (Cholecystectomy)', 'Haemorrhoid Treatment',
    'Wound Care & Management', 'Abdominal Surgery', 'Emergency Surgery',
    'Pre & Post-operative Care', 'Surgical Consultation',
  ],
  specializations: ['General Surgeon', 'Laparoscopic Surgeon'],
  education: [
    { degree: 'MBBS', institute: 'Medical College', year: '' },
    { degree: 'MS — General Surgery', institute: 'Postgraduate Medical Institute', year: '' },
  ],
  awards: [],
  memberships: [],
};

export default function DrMadan() {
  const [activeTab, setActiveTab] = useState('info');
  const tabs = [
    { key: 'info', label: 'Info' },
    { key: 'services', label: `Services (${doctor.services.length})` },
    { key: 'stories', label: 'Patient Stories' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#f7f8fa', fontFamily: "'Segoe UI', sans-serif" }}>

      {/* Breadcrumb */}
      <div style={{ background: '#fff', borderBottom: '1px solid #eaecef', padding: '10px 0' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px', fontSize: 12, color: '#888', display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
          <Link to="/" style={{ color: '#888', textDecoration: 'none' }}>Home</Link><span>›</span>
          <Link to="/doctors" style={{ color: '#888', textDecoration: 'none' }}>Find Doctors</Link><span>›</span>
          <Link to="/doctors?city=Sohna" style={{ color: '#888', textDecoration: 'none' }}>Sohna</Link><span>›</span>
          <Link to="/doctors?specialty=Surgeon" style={{ color: '#888', textDecoration: 'none' }}>Surgeon</Link><span>›</span>
          <span style={{ color: '#333' }}>{doctor.name}</span>
        </div>
      </div>

      <div style={{ maxWidth: 1100, margin: '16px auto', padding: '0 16px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24, alignItems: 'start' }}>

        {/* LEFT */}
        <div>
          {/* Header Card */}
          <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: '26px 26px 0', marginBottom: 16 }}>
            <div style={{ display: 'flex', gap: 20, paddingBottom: 20, borderBottom: '1px solid #eaecef' }}>
              <div style={{ width: 88, height: 88, borderRadius: 4, flexShrink: 0, border: '1px solid #eaecef', background: `${doctor.color}18`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: 26, fontWeight: 700, color: doctor.color }}>{doctor.initials}</span>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 4 }}>
                  <h1 style={{ fontSize: 21, fontWeight: 700, color: '#19354a', margin: 0 }}>{doctor.name}</h1>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: '#2e7d32', fontWeight: 600, background: '#e8f5e9', padding: '2px 8px', borderRadius: 20 }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="#2e7d32"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                    Verified
                  </span>
                </div>
                <p style={{ fontSize: 13, color: '#555', margin: '0 0 3px' }}>{doctor.qual}</p>
                <p style={{ fontSize: 13, color: '#39a5d3', fontWeight: 600, margin: '0 0 6px' }}>{doctor.specialty} — {doctor.specializations.join(', ')}</p>
                <p style={{ fontSize: 12, color: '#888', margin: 0 }}>📍 {doctor.clinic} · {doctor.city}</p>
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              {tabs.map(tab => (
                <button key={tab.key} onClick={() => setActiveTab(tab.key)}
                  style={{ padding: '13px 22px', fontSize: 13, fontWeight: activeTab === tab.key ? 700 : 400, color: activeTab === tab.key ? '#39a5d3' : '#888', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit', borderBottom: activeTab === tab.key ? '2.5px solid #39a5d3' : '2.5px solid transparent', whiteSpace: 'nowrap' }}>
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          {/* INFO TAB */}
          {activeTab === 'info' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 22 }}>
                <h2 style={{ fontSize: 14, fontWeight: 700, color: '#19354a', marginBottom: 10, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>About</h2>
                <p style={{ fontSize: 14, color: '#555', lineHeight: 1.75, margin: 0 }}>{doctor.about}</p>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14 }}>
                <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 22 }}>
                  <h2 style={{ fontSize: 14, fontWeight: 700, color: '#19354a', marginBottom: 12, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>Specializations</h2>
                  {doctor.specializations.map(s => (
                    <div key={s} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#444', marginBottom: 8 }}>
                      <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#39a5d3', flexShrink: 0, marginTop: 5 }} />{s}
                    </div>
                  ))}
                </div>
                <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 22 }}>
                  <h2 style={{ fontSize: 14, fontWeight: 700, color: '#19354a', marginBottom: 12, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>Education</h2>
                  {doctor.education.map((e, i) => (
                    <div key={i} style={{ marginBottom: 10 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>{e.degree}</div>
                      {e.institute && <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{e.institute}{e.year ? `, ${e.year}` : ''}</div>}
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 22 }}>
                <h2 style={{ fontSize: 14, fontWeight: 700, color: '#19354a', marginBottom: 14, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>Clinic Details</h2>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14 }}>
                  {[
                    { label: 'Clinic', value: doctor.clinic },
                    { label: 'Address', value: doctor.location },
                    { label: 'City', value: doctor.city },
                    { label: 'Hours', value: doctor.hours },
                  ].map(item => (
                    <div key={item.label}>
                      <div style={{ fontSize: 11, color: '#aaa', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 4 }}>{item.label}</div>
                      <div style={{ fontSize: 13, color: '#333', lineHeight: 1.5 }}>{item.value}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* SERVICES TAB */}
          {activeTab === 'services' && (
            <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 22 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, paddingBottom: 12, borderBottom: '1px solid #f0f0f0' }}>
                <h2 style={{ fontSize: 14, fontWeight: 700, color: '#19354a', margin: 0 }}>All Services</h2>
                <span style={{ fontSize: 12, color: '#39a5d3', background: '#f0f7fb', padding: '3px 10px', borderRadius: 20, fontWeight: 600 }}>{doctor.services.length} services</span>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 0 }}>
                {doctor.services.map(s => (
                  <div key={s} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '11px 8px', borderBottom: '1px solid #f5f5f5' }}>
                    <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#39a5d3', flexShrink: 0 }} />
                    <span style={{ fontSize: 13, color: '#444' }}>{s}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* STORIES TAB */}
          {activeTab === 'stories' && (
            <ReviewSection doctorId="madan-akropolis" doctorName={doctor.name} />
          )}
        </div>

        {/* RIGHT SIDEBAR */}
        <div style={{ position: 'sticky', top: 20, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: 4, overflow: 'hidden' }}>
            <div style={{ padding: '14px 18px', background: '#f8f9fa', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#19354a' }}>Clinic Appointment</div>
                <div style={{ fontSize: 12, color: '#39a5d3', marginTop: 2 }}>{doctor.clinic}</div>
              </div>
            </div>
            <div style={{ padding: '0 18px' }}>
              {[
                { label: 'Address', value: doctor.location },
                { label: 'Clinic Hours', value: doctor.hours },
              ].map((item, i) => (
                <div key={item.label} style={{ padding: '12px 0', borderBottom: i < 1 ? '1px solid #f0f0f0' : 'none' }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: '#aaa', textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 4 }}>{item.label}</div>
                  <div style={{ fontSize: 13, color: '#333', lineHeight: 1.55 }}>{item.value}</div>
                </div>
              ))}
            </div>
            <SlotPicker doctor={doctor} />
          </div>
          <button onClick={() => setActiveTab('stories')}
            style={{ width: '100%', textAlign: 'center', background: '#fff', color: '#39a5d3', borderRadius: 4, padding: '11px 0', fontSize: 13, fontWeight: 600, border: '1.5px solid #39a5d3', cursor: 'pointer', fontFamily: 'inherit' }}>
            Write a Review
          </button>
          </div>

      </div>
    </div>
  );
}